import html2canvas from 'html2canvas';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import { shareBlobImage } from '../../collab-images/actions';
import { getLocalParticipant, getParticipantById, isWhiteboardParticipant } from '../../base/participants/functions';
import { ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT } from '../../collab-images/constants';
import { getCameraParticipant } from '../../camera-participant/funcions';
class ToastError extends Error {
    constructor(message) {
        super(message);
    }
}
function showErrorToast(text) {
    Toastify({
        text,
        duration: 3000,
        close: false,
        gravity: 'top',
        position: 'right',
        backgroundColor: '#F44336',
        stopOnFocus: true
    }).showToast();
}
/**
 *
 * @param store
 * @param blob
 * @returns {boolean} true si la subida fue despachada false si no.
 */
function dispatchImageUpload(store, blob) {
    const { dispatch, getState } = store;
    try {
        const { excalidrawApi } = getState()['features/collab-images'];
        const { isEnabled } = getState()['features/tego-server'];
        if (!excalidrawApi) {
            showErrorToast('La pizarra colaborativa no esta activa.');
            return false;
        }
        if (!isEnabled) {
            showErrorToast('Caracteristica no activa.');
            return false;
        }
        dispatch(shareBlobImage(blob, excalidrawApi));
        return true;
    }
    catch (error) {
        return false;
    }
}
function validateData(store) {
    const { getState } = store;
    const { conference } = getState()['features/base/conference'];
    const { participantId } = getState()['features/large-video'];
    const localParticipant = getLocalParticipant(getState);
    const participant = participantId ? getParticipantById(getState, participantId) : undefined;
    if (!conference || !participantId || !localParticipant || !participant) {
        throw new ToastError('No se pudo obtener los datos de la videoconferencia.');
    }
    if (isWhiteboardParticipant(participant)) {
        throw new ToastError('No puedes sacar una foto de la pizarra, prueba a exportar la pizarra.');
    }
    return {
        localParticipant,
        participant,
        conference,
    };
}
async function captureBlobAndDispatchOrToast(store, deviceId) {
    // const blob = await captureImageFromCamera(deviceId);
    // if (!blob) throw new ToastError('No se logro obtener los datos de la camara.');
    // dispatchImageUpload(store, blob)
}
/**
     * Captura la imagen de la fuente de video principal.
     *
     * @returns {void}
     */
export async function onScreenShoot() {
    try {
        //@ts-ignore
        const store = APP.store;
        const { getState } = store;
        const { conference, localParticipant, participant } = validateData(store);
        if (localParticipant.id == participant.id) {
            captureImageLargeVideo();
        }
        else {
            const cameraParticipant = getCameraParticipant(getState, participant.id);
            if (cameraParticipant) {
                captureBlobAndDispatchOrToast(store, cameraParticipant.deviceId);
            }
            else {
                conference.sendMessage({
                    type: ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT,
                    payload: {
                        participantId: participant.id,
                        fromParticipantId: localParticipant.id,
                    }
                });
            }
        }
    }
    catch (error) {
        if (error instanceof ToastError) {
            showErrorToast(error.message);
        }
        else {
            showErrorToast("Ha ocurrio un error");
        }
    }
}
export async function requestCapture() {
    try {
        //@ts-ignore
        const store = APP.store;
        const { getState } = store;
        const { localParticipant, participant, conference } = validateData(store);
        if (localParticipant.id == participant.id) {
            if (!localParticipant.cameraDeviceId)
                throw new ToastError("No se encontro la camara");
            await captureBlobAndDispatchOrToast(store, localParticipant.cameraDeviceId);
        }
        else {
            const cameraParticipant = getCameraParticipant(getState, participant.id);
            if (cameraParticipant) {
                await captureBlobAndDispatchOrToast(store, cameraParticipant.deviceId);
            }
            else {
                conference.sendMessage({
                    type: ENDPOINT_MESSAGE_RECEIVED_TAKE_CAPTURE_OF_PARTICIPANT,
                    payload: {
                        participantId: participant.id,
                        fromParticipantId: localParticipant.id,
                    }
                });
            }
        }
    }
    catch (error) {
        if (error instanceof ToastError) {
            showErrorToast(error.message);
        }
        else {
            showErrorToast("Ha ocurrio un error");
        }
    }
}
export async function captureImageLargeVideo() {
    try {
        //@ts-ignore
        const store = APP.store;
        validateData(store);
        const element = document.getElementById('largeVideo');
        if (!element)
            throw new ToastError('No hay ninguna cámara seleccionada como principal.');
        const canvas = await html2canvas(element);
        canvas.toBlob(async (blob) => {
            if (!blob) {
                showErrorToast('No hay ninguna cámara seleccionada como principal.');
                return;
            }
            flashEffect();
            Toastify({
                text: '¡Captura realizada con éxito!',
                duration: 3000,
                close: false,
                gravity: 'top',
                position: 'right',
                backgroundColor: '#4CAF50',
                stopOnFocus: true
            }).showToast();
            await addImageToClipBoard(blob);
            dispatchImageUpload(store, blob);
        }, 'image/png');
    }
    catch (error) {
        if (error instanceof ToastError) {
            showErrorToast(error.message);
        }
        else {
            showErrorToast("Ha ocurrio un error");
        }
    }
}
/**
     * Copia una imagen al portapapeles.
     *
     * @param {Blob} image - Imagen a copiar al portapapeles.
     * @returns {Promise<void>} - Promesa que se resuelve cuando la imagen se copia.
     */
async function addImageToClipBoard(image) {
    const item = new ClipboardItem({ 'image/png': image });
    await navigator.clipboard.write([item]);
}
/**
 * Comprime / redimensiona un Blob de imagen.
 * @param blob Blob de la imagen original.
 * @param maxWidth Ancho máximo deseado.
 * @param maxHeight Alto máximo deseado.
 * @param quality Calidad para JPEG (0–1). Ignorado si usas PNG.
 * @returns Promise<Blob> del nuevo blob comprimido.
 */
export async function compressImageBlob(blob, maxWidth, maxHeight, quality = 0.8) {
    // 1) Leemos el blob en un DataURL
    const dataURL = await new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
    // 2) Creamos un elemento Image
    const img = await new Promise((resolve, reject) => {
        const i = new Image();
        i.onload = () => resolve(i);
        i.onerror = reject;
        i.src = dataURL;
    });
    // 3) Calculamos dimensiones manteniendo aspecto
    let { width, height } = img;
    const aspect = width / height;
    if (width > maxWidth) {
        width = maxWidth;
        height = Math.round(width / aspect);
    }
    if (height > maxHeight) {
        height = maxHeight;
        width = Math.round(height * aspect);
    }
    // 4) Dibujamos en canvas
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    // 5) Extraemos el blob comprimido
    // Para JPEG usa 'image/jpeg' y quality; para PNG usa 'image/png'
    return await new Promise(resolve => canvas.toBlob(blobOut => resolve(blobOut), 'image/jpeg', quality));
}
/**
 *  Agrega el efecto de flash al elemento que contiene la imagen objetiva.
 *
 * @param { HTMLElement } target - Objetivo para  agregar el efecto de flash.
 * @returns {void}
 */
function flashEffect() {
    const target = document.getElementById('largeVideoWrapper');
    if (!target) {
        console.error(`Elemento con id "${target}" no encontrado`);
        return;
    }
    const overlay = createEffectDiv();
    target.appendChild(overlay);
    overlay.style.opacity = '1';
    setTimeout(() => {
        overlay.style.opacity = '0';
    }, 100);
}
/**
 * Crea el elemento para agregar el efecto de captura de imagen.
 *
 * @returns {HTMLDivElement} Div que contiene el div con el efecto en cuestión.
 */
function createEffectDiv() {
    const divAffected = document.createElement('div');
    addFlashEffect(divAffected);
    return divAffected;
}
/**
 * Agrega el efecto de flash a un div.
 *
 * @param {HTMLDivElement} divAffected - Div al que se le agregará el efecto.
 * @returns {void}
*/
function addFlashEffect(divAffected) {
    divAffected.className = 'flash-overlay';
    divAffected.style.position = 'absolute';
    divAffected.style.top = '0';
    divAffected.style.left = '0';
    divAffected.style.width = '100%';
    divAffected.style.height = '100%';
    divAffected.style.background = 'white';
    divAffected.style.opacity = '0';
    divAffected.style.pointerEvents = 'none';
    divAffected.style.transition = 'opacity 0.3s ease-in-out';
    divAffected.style.zIndex = '10';
}
